module.exports = __webpack_public_path__ + "static/media/paint_medium.63dfef8e.webp";